import { MAIN_PAGE_TITLE } from '@/shared/constants/seoConstants';
import { MAIN_PAGE_FAQ_QUESTIONS } from '@/shared/constants/faqConstants';
import { buildFaqData, type FaqSchemaData } from '@/shared/utils/buildSchemaData';
import {
  SCHEMA_LANGUAGE,
  buildAbsoluteUrl,
  buildPageId,
  organizationReference,
  websiteReference,
  type SchemaNode,
} from '@/shared/lib/schema';

const MAIN_PAGE_URL: string = buildAbsoluteUrl('/');

export const mainPageGraph: SchemaNode[] = [
  {
    '@type': 'WebPage',
    '@id': buildPageId(MAIN_PAGE_URL),
    url: MAIN_PAGE_URL,
    name: MAIN_PAGE_TITLE,
    isPartOf: websiteReference,
    about: organizationReference,
    inLanguage: SCHEMA_LANGUAGE,
  },
];

export const faqData: FaqSchemaData = buildFaqData(MAIN_PAGE_FAQ_QUESTIONS);
